import { Tabs } from '@material-ui/core';
import { ThemeProvider } from 'emotion-theming';
import React, { Component } from 'react';

import IChatOptions from '../../interfaces/IChatOptions';
import { FormInputLabel } from '../Typography';
import ChatButtonEditor from './components/ChatButtonEditor/ChatButtonEditor';
import ImportDialogue from './components/ImportDialogue';
import WidgetCodeGenerator from './components/WidgetCodeGenerator';
import WidgetEditor from './components/WidgetEditor/WidgetEditor';
import {
  GeneratorContent,
  ImportButtonContainer,
  StyledTab,
  TabContainer,
  WidgetCodeContainer,
  WidgetGeneratorContainer,
} from './styled';

export interface IWidgetGeneratorProps {
}

export interface IWidgetGeneratorState extends IChatOptions {
  tempLogoUrl: string;
  activeTab: number;
}

class WidgetGenerator extends Component<IWidgetGeneratorProps, IWidgetGeneratorState> {

  protected script: HTMLScriptElement | null = null;
  protected widgetEditorRef: WidgetEditor | null = null;

  constructor(props: IWidgetGeneratorProps) {
    super(props);

    const options: IChatOptions = {
      env: 'widget-generator',
      apiKey: 'widget-generator',
      width: 400,
      height: 600,
      initialMessage: 'Hello, this is the greeting message.',
      initialResponses: [],
      logoUrl: '',
      title: 'Welcome',
      primaryAccentColor: '#FF0000',
      primaryAccentTextColor: '#FFFFFF',
      backgroundColor: '#FFFFFF',
      agentBubbleBackgroundColor: '#FF0000',
      agentBubbleTextColor: '#FFFFFF',
      bubbleBackgroundColor: '#F1F1F1',
      bubbleTextColor: '#000000',
      sendButtonBackgroundColor: '#FF0000',
      sendButtonTextColor: '#FFFFFF',
      suggestedResponseColor: '#FF0000',
      autoOpen: false,
      autoOpenMobile: false,
      position: 'right',
      buttonBackgroundColor: '#3c425c',
      buttonText: 'Chat with Us',
      buttonTextColor: '#FFFFFF',
    };

    this.state = {
      ...options,
      tempLogoUrl: options.logoUrl,
      activeTab: 0,
    };
  }

  public render() {

    const {
      activeTab,
    } = this.state;

    return (
      <ThemeProvider theme={this.state}>
        <WidgetGeneratorContainer>
          <FormInputLabel bold>CLIENT CUSTOMIZER</FormInputLabel>
          <Tabs
            indicatorColor='primary'
            value={activeTab}
            onChange={(_, value) => this.setState({ activeTab: value })}
          >
            <StyledTab label='Widget Editor' />
            <StyledTab label='Chat Button Editor' />
          </Tabs>
          <GeneratorContent>
            {activeTab === 0 && (
              <TabContainer>
                <WidgetEditor
                  ref={o => this.widgetEditorRef = o}
                  options={this.state}
                  updateWidget={(key, value, refresh) => this.updateWidget(key, value, refresh)}
                />
              </TabContainer>
            )}

            {activeTab === 1 && (
              <TabContainer>
                <ChatButtonEditor
                  options={this.state}
                  updateWidget={(key, value) => this.updateWidget(key, value)}
                />
              </TabContainer>
            )}

            <WidgetCodeContainer>
              <WidgetCodeGenerator options={this.state} />
            </WidgetCodeContainer>

            <ImportButtonContainer>
              <ImportDialogue handleImportProps={importProps => this.handleImport(importProps)} />
            </ImportButtonContainer>
          </GeneratorContent>

        </WidgetGeneratorContainer>
      </ThemeProvider>
    );
  }

  private updateWidget(key: string, value: string | number | boolean | string[], refresh?: boolean) {
    if (key === 'autoOpenDelay' || key === 'autoOpenMobileDelay') {
      const numberValue = parseInt(value as string, 10);
      if (!isNaN(numberValue)) {
        this.setState(
          { [key]: numberValue } as any,
          () => refresh ? this.widgetEditorRef && this.widgetEditorRef.refreshWidget() : null,
        );
      }
      return;
    }

    this.setState(
      { [key]: value } as any,
      () => refresh ? this.widgetEditorRef && this.widgetEditorRef.refreshWidget() : null,
    );

    if (key === 'primaryAccentColor') {
      this.updateWidget('agentBubbleBackgroundColor', value);
      this.updateWidget('sendButtonBackgroundColor', value);
      this.updateWidget('suggestedResponseColor', value);
    } else if (key === 'primaryAccentTextColor') {
      this.updateWidget('agentBubbleTextColor', value);
      this.updateWidget('sendButtonTextColor', value);
    }
  }

  private handleImport(importOptions: string) {
    const parsedJSON = JSON.parse(importOptions);

    if (parsedJSON) {
      this.setState({ ...parsedJSON } as any);
    }
  }
}

export default WidgetGenerator;
